module.exports = __webpack_public_path__ + "static/media/3.ca20978b.jpg";